/** @jsxImportSource react */
import React from "react";

import { colorCSS } from "../../styles/colors";

// SSR-compatible components using inline styles instead of Compiled CSS

export const Wrapper = ({
    children,
    ...props
}: React.HTMLAttributes<HTMLDivElement>) => (
    <div style={{ position: "relative" }} {...props}>
        {children}
    </div>
);

type FadeProps = React.HTMLAttributes<HTMLDivElement> & {
    fadeHeight: number;
    fadeColor: string;
};

export const Fade = ({ fadeHeight, fadeColor, style, ...props }: FadeProps) => (
    <div
        style={{
            background: `linear-gradient(${colorCSS(fadeColor, 0)}, ${colorCSS(
                fadeColor,
                1
            )})`,
            height: `${fadeHeight}px`,
            left: 0,
            position: "absolute",
            transition: "bottom 0.25s",
            width: "100%",
            ...style
        }}
        {...props}
    />
);
